import { render, staticRenderFns } from "./CalendarGroupComponent.vue?vue&type=template&id=60f6b595&scoped=true"
import script from "./CalendarGroupComponent.vue?vue&type=script&lang=ts"
export * from "./CalendarGroupComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60f6b595",
  null
  
)

export default component.exports